// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2e83fc66","94":"07e976f8","129":"8c3efa74","758":"2f0d83b7","932":"14f53677","953":"6770288a"}[chunkId] + ".chunk.js";
};